import { render, staticRenderFns } from "./formulaDemo.vue?vue&type=template&id=428b9a7f&scoped=true&"
import script from "./formulaDemo.vue?vue&type=script&lang=js&"
export * from "./formulaDemo.vue?vue&type=script&lang=js&"
import style0 from "./formulaDemo.vue?vue&type=style&index=0&id=428b9a7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428b9a7f",
  null
  
)

export default component.exports